// extracted by mini-css-extract-plugin
export default {"root":"card-container_root__Y39x9","bordered":"card-container_bordered__TYPwu","divider":"card-container_divider__GWnoB"};